import React from 'react';
import '../App.css';
import Hero from '../images/avtar.svg'

const HeroSection = () => {
    return(
        <div>
        <header className="masthead bg-primary text-white text-center">
            <div className="container d-flex align-items-center flex-column">
                <img className="masthead-avatar mb-5" src={Hero} alt="Hero"/>
                <h3 className="masthead-heading mb-0 banner-anim">Hi, I'm Sajid.</h3>

                <div className="divider-custom divider-light">
                    <div className="divider-custom-line"></div>
                    <div className="divider-custom-icon"><i class="fab fa-sketch"></i></div>
                    <div className="divider-custom-line"></div>
                </div>
                <div className="row">
                <div className="col-md-12">
                <p className="masthead-subheading font-weight-light mb-0">Front-end Developer - Web Designer - Graphic Artist - Android App Developer</p>
                </div>
                </div>
                </div>
        </header>
        </div>
    );
}

export default HeroSection;